import React, {FC} from 'react';
import styled from 'styled-components';

import {ChromelessButton} from '../../../../libs/shared/ui/src/components/buttons/chromelessButton';
import {Icon} from '../../../../libs/shared/ui/src/components/icon/icon';

/*
 * Props.
 */

interface InfoBubbleCloseButtonProps {
  onClose: () => void;
  interactionId?: string;
}

/*
 * Style.
 */

const StyledIconDiv = styled(Icon)`
  position: absolute;
  top: 13.5px;
  right: 13.5px;
  color: ${(p) => p.theme.greys.shade60};
  &:hover {
    color: ${(p) => p.theme.greys.shade70};
  }
`;

/*
 * Component.
 */

export const InfoBubbleCloseButton: FC<InfoBubbleCloseButtonProps> = (props) => (
  <ChromelessButton onClick={props.onClose} interactionId={props.interactionId}>
    <StyledIconDiv name="closeSmall" size={16} />
  </ChromelessButton>
);
